import { fetchData, useFetch } from "lib/helpers/fetchData";
import styled from "styled-components";

import {
  faAudioDescription,
  faBiohazard,
  faBookOpen,
  faEnvelope,
  faFileContract,
  faHospitalUser,
  faLock,
  faRocket,
  faShieldAlt,
  faRobot,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListPane, StyledListItem } from "lib/components/ListPane";
import { getApiUrl } from "lib/helpers/getApiUrl";
import { SingleCustomer } from "./components/SingleCustomer";
import { UpsertCustomer } from "./components/UpsertCustomer";

export const loadCustomersList = async () => {
  return await fetchData(`${getApiUrl("ADMIN_API")}/customers-with-exclusions`);
};

const StyledIcon = styled(FontAwesomeIcon)`
  font-size: 1.3rem;
  margin-left: 0.5rem;
  color: ${(props) => props.accent || props.theme.text};
  opacity: ${(props) => (props.active === "true" ? 0.7 : 0.1)};
`;

const getSocIconColour = (ingestionOption) => {
  switch (ingestionOption) {
    case "ecl":
      return "#00a1e6";
    case "integrations":
      return "#d40075";
    default:
      return "";
  }
};

export const Customers = () => {
  const state = useFetch(loadCustomersList);
  const renderListItemIcons = (customer = {}) => (
    <>
      {customer.auth?.sso?.enabled && <StyledIcon title="AD SSO" icon={faAudioDescription} active="true" />}
      {customer.apps?.soc?.mispTI && <StyledIcon title="MISP TI" icon={faBookOpen} active="true" />}
      {customer.apps?.soc?.resourceOrchestrator && <StyledIcon title="Resource Orchestrator" icon={faRocket} active="true" />}
      <StyledIcon
        title="Soc"
        icon={faShieldAlt}
        active={`${customer.apps?.["soc"]?.enabled}`}
        accent={getSocIconColour(customer?.apps?.soc?.ingestion)}
      />
      <StyledIcon title="Vuln" icon={faBiohazard} active={`${customer.apps?.["vuln"]?.enabled}`} />
      <StyledIcon title="Phish" icon={faEnvelope} active={`${customer.apps?.["phish"]?.enabled}`} />
      <StyledIcon title="MDS Service" icon={faFileContract} active={`${customer.apps?.["mds"]?.enabled}`} />
      <StyledIcon title="Operational Technology" icon={faRobot} active={`${customer.apps?.["ot"]?.enabled}`} />
      <StyledIcon title="Automated Identity MDR" icon={faHospitalUser} active={`${customer.apps?.["aimdr"]?.enabled}`} />
    </>
  );

  const renderListItem = ({ item: customer, isActive, onClick }) => {
    if (customer.exclusionType === "PermissionException") {
      return (
        <StyledListItem id={customer.id} key={customer.id} style={{ opacity: 0.5, cursor: "not-allowed", fontStyle: "italic" }}>
          <p className="title">{customer.name}</p>
          <StyledIcon title="No access" icon={faLock} active="true" />
        </StyledListItem>
      );
    }

    return (
      <StyledListItem id={customer.id} key={customer.id} active={isActive} onClick={onClick}>
        <p className="title">{customer.name}</p>
        {renderListItemIcons(customer)}
      </StyledListItem>
    );
  };
  return (
    <ListPane
      sort
      hasSearch
      renderListItem={renderListItem}
      listState={state}
      listName="Customer"
      listWidth={400}
      upsertPane={UpsertCustomer}
      singleItemPane={SingleCustomer}
    />
  );
};
